import * as yup from 'yup';

import { Row, RenderConfig, DateRangeInput, MIN_DATE, MAX_DATE, MIN_DATE_OBJECT, MAX_DATE_OBJECT, TextInput } from 'commons-ui';

const FORM_FIELD_KEYS = {
	DATE_RANGE: 'dateRange',
	TIDS_TO_HIGHLIGHT: 'tidsToHighlight'
};

export const validationSchema = yup.object().shape({
	dateRange: yup
		.array()
		.test({
			message: 'Invalid date range',
			test: (value: any) => value.length === 2 || value.length === 0
		})
		.test({
			message: `"from" date must be in a range of ${MIN_DATE} to ${MAX_DATE}`,
			test: (value: any) => value.length === 0 || (value[0] >= MIN_DATE_OBJECT && value[0] <= MAX_DATE_OBJECT)
		})
		.test({
			message: `"To" date must be in a range of ${MIN_DATE} to ${MAX_DATE}`,
			test: (value: any) => value.length === 0 || (value[1] >= MIN_DATE_OBJECT && value[1] <= MAX_DATE_OBJECT)
		})
});

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.DATE_RANGE]: new RenderConfig()
		.setName('dateRange')
		.setLabel('Date Range')
		.setRenderer(DateRangeInput)
		.setRenderProps({
			isEditable: { create: true, edit: true }
		}),
	[FORM_FIELD_KEYS.TIDS_TO_HIGHLIGHT]: new RenderConfig()
		.setName('tidsToHighlight')
		.setLabel('Transaction IDs')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			placeholder: 'Enter transaction IDs separated by commas'
		})
};

export const FORM_LAYOUT_CONFIG = [new Row(FORM_FIELD_KEYS.DATE_RANGE), new Row(FORM_FIELD_KEYS.TIDS_TO_HIGHLIGHT)];
